
import {
    GET_ALL_FLAT_SIZE
   } from "../../constant/ActionType";
   
   export default function GetAllFlatSize(state = {
       AllFlatSizeData: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_FLAT_SIZE:
               return {
                   ...state,
                   AllFlatSizeData: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }